import { ApiRouteTypes } from "consts/enpoints/api";
import { concat } from "util/support";
import { sliceToken } from "./state";

export const loginThunkType = concat([sliceToken, ApiRouteTypes.PostLogin]);
export const logoutThunkType = concat([sliceToken, ApiRouteTypes.PostLogout]);
export const fetchUserThunkType = concat([sliceToken, ApiRouteTypes.GetUserById]);
export const authLogoutActionType = concat([sliceToken, 'logout'], { token: '/' });
